import { enqueueSnackbar } from "notistack";

export const useToast = (
  message: string,
  {
    variant = "default",
    anchorOrigin = { vertical: "bottom", horizontal: "right" },
  }: {
    variant?: "error" | "default" | "success" | "warning" | "info" | undefined;
    anchorOrigin?: {
      horizontal: "left" | "center" | "right";
      vertical: "top" | "bottom";
    };
  }
) => {
  enqueueSnackbar(message, { variant, anchorOrigin });
};
